import { render } from "./LoanApplications.vue?vue&type=template&id=3484dc94"
import script from "./LoanApplications.vue?vue&type=script&lang=js"
export * from "./LoanApplications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__